import { render, staticRenderFns } from "./base.vue?vue&type=template&id=7d0c9c0c"
import script from "./base.vue?vue&type=script&lang=js"
export * from "./base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d0c9c0c')) {
      api.createRecord('7d0c9c0c', component.options)
    } else {
      api.reload('7d0c9c0c', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=7d0c9c0c", function () {
      api.rerender('7d0c9c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/attachment/types/base.vue"
export default component.exports